// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.ptt-compare-wrapper {
  overflow-x: auto;
  margin: 8px 0;
}

.ptt-compare-scroll {
  overflow-x: auto;
}

.ptt-compare-table {
  border-collapse: collapse;
  font-size: 14px;
}
.ptt-compare-table th,
.ptt-compare-table td {
  border: 1px solid #ddd;
  padding: 4px 10px;
  text-align: center;
  white-space: nowrap;
}
.ptt-compare-table .ptt-compare-header {
  background: #f7f7f7;
  font-weight: bold;
  text-align: left;
  padding: 4px 8px;
}

.ptt-cell-old {
  display: block;
  color: #c62828;
  text-decoration: line-through;
  font-size: 0.85em;
  line-height: 1.3;
}

.ptt-cell-new {
  display: block;
  color: #2e7d32;
  font-weight: 500;
  font-size: 0.85em;
  line-height: 1.3;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
